import { Extension } from "@tiptap/core"
import { PluginKey } from "@tiptap/pm/state"
import Suggestion from "@tiptap/suggestion"

import type { MacroVariable } from "@productlane/lib/src/macro-variables"
import {
	macroVariableToken,
	searchMacroVariables,
} from "@productlane/lib/src/macro-variables"

import type { MacroVariableCommandProps } from "./types"
import type { SuggestionOptions } from "@tiptap/suggestion"
import { macroVariableSuggestionRenderer } from "./suggestion"

export const MacroVariablePluginKey = new PluginKey("macroVariableSuggestion")

export const MACRO_VARIABLE_SUGGESTION_LIMIT = 8

// A closed bracket is the finished token, so the list steps aside.
export function getMacroVariableItems(query: string): MacroVariable[] {
	if (query.includes("]")) return []
	return searchMacroVariables(query, MACRO_VARIABLE_SUGGESTION_LIMIT)
}

export interface MacroVariableSuggestionOptions {
	suggestion: Omit<
		SuggestionOptions<MacroVariable, MacroVariableCommandProps>,
		"editor"
	>
}

export const macroVariableSuggestionOptions: MacroVariableSuggestionOptions["suggestion"] =
	{
		char: "[",
		pluginKey: MacroVariablePluginKey,
		allowSpaces: false,
		startOfLine: false,
		items: ({ query }) => getMacroVariableItems(query),
		render: macroVariableSuggestionRenderer,
		command: ({ editor, range, props }) => {
			editor
				.chain()
				.focus()
				.insertContentAt(range, macroVariableToken(props.key))
				.run()
		},
	}

export const MacroVariableSuggestion =
	Extension.create<MacroVariableSuggestionOptions>({
		name: "macroVariableSuggestion",

		addOptions() {
			return { suggestion: macroVariableSuggestionOptions }
		},

		addProseMirrorPlugins() {
			return [
				Suggestion({
					editor: this.editor,
					...this.options.suggestion,
				}),
			]
		},
	})
